import React, { useState } from 'react';

interface CheckboxProps {
  checked?: boolean;
  onChange: (checked: boolean) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked = false, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    onChange(checked);
  };

  return (
    <div className="flex justify-center items-center w-auto h-full">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="cursor-pointer accent-blue-500 hover:accent-blue-600 transition-colors"
        style={{
          width: "2vh",
          height: "2vh",
        }}
      />
    </div>
  );
};

export default Checkbox;
